import { render, staticRenderFns } from "./VPreloader.vue?vue&type=template&id=7a073396"
import script from "./VPreloader.vue?vue&type=script&lang=js"
export * from "./VPreloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports